import {
  PRODUCTO_CARRITO_HAS_ERRORED,
  SET_DATA_CARRITO_DETALLE,
  PRODUCTO_CARRITO_IS_LOADING,
  LIMPIAR_CARRITO,
  VALIDAR_PLACAS_POLIZA,
  MSG_VALIDAR_PLACAS_POLIZA,
  LIMPIAR_DATOS_VALIDACIONES_PLACA,
  setCarritoHogar,
  planesHogarAdvanceError,
  planesHogarAdvanceLoading,
  setPlanesHogarAdvance,
  carritoHogarError,
  carritoHogarloading,
  limpiarCarritoHogar,
  setSeccionesCoberturasHogar,
  seccionesCoberturasHogarloading,
  seccionesCoberturasHogarError,
  limpiarSeccionesCoberturasHogar,
  limpiarPlanesHogarAdvance,
  setCalculoPrimaHogar,
  calculoPrimaHogarloading,
  calculoPrimaHogarError,
  limpiarCalculoPrimaHogar,
  setCalculoPrimaHogarErrores,
  limpiarErroresCalculoPrimaHogar,
  setProductoActualHogar,
  limpiarProductoActualHogar,
  generarPdfCotizacionHogarloading,
  generarPdfCotizacionHogarError,
  setGenerarPdfCotizacionHogar,
  limpiarTotalesCabeceraCotizadores,
  setTotalesCabeceraCotizadores,
  // manejo de duplicidades hogar
  setIsDuplicatePoliza,
  setDuplicidadPolizaLoading,
  setDuplicidadPolizaError,
  LIMPIAR_LISTA_NEGRA,
  SET_DATA_PlANES_COMPARADOR,
  setDataPlanesCotizacion
} from "../actions/ACarritoProductos";
import { handleActions } from 'redux-actions'
import { setInListaNegra, setListaNegraError, setListaNegraLoading, setInListaNegraMensaje, limpiarInListaNegra } from "../actions/ACarritoProductos";

const initialState = {
  isLoading: false,
  hasErrored: false,
  productosCarrito: {},
  SetValidarPlacasPoliza: true,
  msgValidarPlacas: undefined
};
export default function dataProductoCarrito(state = initialState, action) {
  switch (action.type) {
    case PRODUCTO_CARRITO_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        hasErrored: false
      };
    case SET_DATA_CARRITO_DETALLE:
      return {
        ...state,
        isLoading: false,
        productosCarrito: action.productosCarrito,
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: undefined
      };
    case SET_DATA_PlANES_COMPARADOR:
      return {
        ...state,
        isLoading: false,
        planesComparador: action.planesComparador,
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: undefined
      };
    case PRODUCTO_CARRITO_HAS_ERRORED:
      return {
        ...state,
        isLoading: false,
        hasErrored: true
      };
    case LIMPIAR_CARRITO:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        productosCarrito: {},
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: undefined
      };
    case VALIDAR_PLACAS_POLIZA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        SetValidarPlacasPoliza: false
      };
    case MSG_VALIDAR_PLACAS_POLIZA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        msgValidarPlacas: action.payload
      };
    case LIMPIAR_DATOS_VALIDACIONES_PLACA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: ""
      };
    default:
      return state;
  }
}

//COTIZACION HOGAR ----------------------------------------
export const datosDuplicidadPolizas = handleActions(
  {
    // Manejar las duplicidades en hogar
    [setIsDuplicatePoliza]: (state, action) => ({ ...state, isDuplicatePoliza: action.payload }),
    [setDuplicidadPolizaLoading]: (state, action) => ({ ...state, duplicidadPolizaLoading: action.payload }),
    [setDuplicidadPolizaError]: (state, action) => ({ ...state, duplicidadPolizaError: action.payload }),
  },
  // initial state
  {
    isDuplicatePoliza: false,
    duplicidadPolizaLoading: false,
    duplicidadPolizaError: false,
  }
)

export const dataPlanesComparador = handleActions(
  {
    [setDataPlanesCotizacion]: (state, action) => ({ ...state, planesComparador: action.payload }),
  },
  { planesComparador: [] }


)

//LISTA NEGRA
export const datosListaNegra = handleActions(
  {
    // Manejar la lista negra
    [setInListaNegra]: (state, action) => ({ ...state, inListaNegra: action.payload }),
    [setListaNegraLoading]: (state, action) => ({ ...state, listaNegraLoading: action.payload }),
    [limpiarInListaNegra]: (state) => ({ ...state, setInListaNegra: false, listaNegraError: false, listaNegraLoading: false }),
    [setListaNegraError]: (state, action) => ({ ...state, listaNegraError: action.payload }),
    [setInListaNegraMensaje]: (state, action) => ({ ...state, inListaNegraMensaje: action.payload }),
  },
  // initial state
  {
    inListaNegra: false,
    listaNegraLoading: false,
    listaNegraError: false,
    inListaNegraMensaje: ''
  }
)


export const datosCarritoHogar = handleActions(
  {
    //Guardar informacion en el carrito
    [carritoHogarloading]: (state) => ({ ...state, carritoHogarloading: true, carritoHogarError: false, }),
    [carritoHogarError]: (state) => ({ ...state, carritoHogarError: true, carritoHogarloading: false }),
    [setCarritoHogar]: (state, action) => ({ ...state, setCarritoHogar: action.payload, carritoHogarError: false, carritoHogarloading: false }),
    [limpiarCarritoHogar]: (state) => ({ ...state, setCarritoHogar: {}, carritoHogarError: false, carritoHogarloading: false }),
    //Listar secciones y coberturas
    [seccionesCoberturasHogarloading]: (state) => ({ ...state, seccionesCoberturasHogarloading: true, seccionesCoberturasHogarError: false, }),
    [seccionesCoberturasHogarError]: (state) => ({ ...state, seccionesCoberturasHogarError: true, seccionesCoberturasHogarloading: false }),
    [setSeccionesCoberturasHogar]: (state, action) => ({ ...state, setSeccionesCoberturasHogar: action.payload, seccionesCoberturasHogarError: false, seccionesCoberturasHogarloading: false }),
    [limpiarSeccionesCoberturasHogar]: (state) => ({ ...state, setSeccionesCoberturasHogar: {}, seccionesCoberturasHogarError: false, seccionesCoberturasHogarloading: false }),
    [limpiarPlanesHogarAdvance]: (state) => ({ ...state, setPlanesHogarAdvance: {}, planesHogarAdvanceError: false, planesHogarAdvanceLoading: false }),
    //Calcular la prima 
    [calculoPrimaHogarloading]: (state) => ({ ...state, calculoPrimaHogarloading: true, calculoPrimaHogarError: false, }),
    [calculoPrimaHogarError]: (state) => ({ ...state, calculoPrimaHogarError: true, calculoPrimaHogarloading: false }),
    [setCalculoPrimaHogar]: (state, action) => ({ ...state, setCalculoPrimaHogar: action.payload, calculoPrimaHogarError: false, calculoPrimaHogarloading: false }),
    [limpiarCalculoPrimaHogar]: (state) => ({ ...state, setCalculoPrimaHogar: {}, calculoPrimaHogarError: false, calculoPrimaHogarloading: false }),

    [setCalculoPrimaHogarErrores]: (state, action) => ({ ...state, setCalculoPrimaHogarErrores: action.payload }),
    [limpiarErroresCalculoPrimaHogar]: (state, action) => ({ ...state, setCalculoPrimaHogarErrores: {} }),
    //Establecer producto actual hogar
    [setProductoActualHogar]: (state, action) => ({ ...state, setProductoActualHogar: action.payload }),
    [limpiarProductoActualHogar]: (state, action) => ({ ...state, limpiarProductoActualHogar: {} }),
    //Generar o enviar pdf cotizacion hogar
    [generarPdfCotizacionHogarloading]: (state) => ({ ...state, generarPdfCotizacionHogarloading: true, generarPdfCotizacionHogarError: false }),
    [generarPdfCotizacionHogarError]: (state) => ({ ...state, generarPdfCotizacionHogarError: true, generarPdfCotizacionHogarloading: false }),
    [setGenerarPdfCotizacionHogar]: (state, action) => ({ ...state, setGenerarPdfCotizacionHogar: action.payload, generarPdfCotizacionHogarError: false, generarPdfCotizacionHogarloading: false }),
    [planesHogarAdvanceLoading]: (state) => ({ ...state, planesHogarAdvanceLoading: true, planesHogarAdvanceError: false, }),
    [planesHogarAdvanceError]: (state) => ({ ...state, planesHogarAdvanceError: true, planesHogarAdvanceLoading: false }),
    [setPlanesHogarAdvance]: (state, action) => ({ ...state, setPlanesHogarAdvance: action.payload, planesHogarAdvanceError: false, planesHogarAdvanceLoading: false }),

  },
  {
    // manejo del carrito
    carritoHogarloading: false,
    carritoHogarError: false,
    setCarritoHogar: {},

    setSeccionesCoberturasHogar: {},
    seccionesCoberturasHogarloading: false,
    seccionesCoberturasHogarError: false,

    setCalculoPrimaHogar: {},
    calculoPrimaHogarloading: false,
    calculoPrimaHogarError: false,

    setCalculoPrimaHogarErrores: {},

    setProductoActualHogar: {},

    setGenerarPdfCotizacionHogar: {},
    generarPdfCotizacionHogarloading: false,
    generarPdfCotizacionHogarError: false,

    planesHogarAdvanceLoading: false,
    planesHogarAdvanceError: false,
    setPlanesHogarAdvance: {},
  }
);


//FIN COTIZACION HOGAR ----------------------------------------
export const datosTotalesCabeceraCotizadores = handleActions(
  {
    //Establecer totales cabecera Cotizadores
    [setTotalesCabeceraCotizadores]: (state, action) => ({ ...state, setTotalesCabeceraCotizadores: action.payload }),
    [limpiarTotalesCabeceraCotizadores]: (state, action) => ({ ...state, setTotalesCabeceraCotizadores: { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" } }),
  },
  {
    setTotalesCabeceraCotizadores: { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" },
  }
);

//TOTALES CABECERA COTIZADORES ----------------------------------------